/*eslint-disable*/
export default [
    {
        path: 'billing/:id/edit',
        name: 'billing:edit',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "billing" */'../../components/billing/Edit.vue'),
        meta: {
            title: 'router.router_editBilling',
            prev: {
                name: 'transactions:list'
            }
        },
        props: true
    },
    {
        path: 'billing/transactions',
        name: 'transactions:list',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "billing" */'../../components/lists/List.vue'),
        meta: {
            title: 'router.router_billing',
            prev: {
                name: 'dashboard'
            }
        },
        props ($route) {
            return {
                type: 'transactions',
                page: $route.query.page,
                withoutCreate: true,
            }
        }
    },
    {
        path: 'billing/stocks',
        name: 'stocks:list',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "billing" */'../../components/lists/List.vue'),
        meta: {
            title: 'router.router_stocks',
            prev: {
                name: 'dashboard'
            }
        },
        props ($route) {
            return {
                type: 'stocks',
                page: $route.query.page,
                withoutCreate: false,
            }
        }
    },
    {
        path: 'billing/stocks/create',
        name: 'stocks:create',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "billing" */'../../components/billing/stocks/Create.vue'),
        meta: {
            title: 'router.router_addStock',
            prev: {
                name: 'stocks:list'
            }
        },
        props ($route) {
            return {
                copy: $route.params.copy,
                page: $route.query.page,
                type: $route.params.type || 'stocks'
            }
        }
    },
    {
        path: 'billing/stocks/:id/edit',
        name: 'stocks:edit',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "billing" */'../../components/billing/stocks/Create.vue'),
        meta: {
            title: 'router.router_editStock',
            prev: {
                name: 'stocks:list'
            }
        },
        props ($route) {
            return {
                id: $route.params.id,
                type: $route.params.type || 'stocks',
                page: $route.query.page,
                copy: $route.params.copy,
            }
        }
    },
    {
        path: 'billing/subscriptions',
        name: 'subscriptions:list',
        component: () => import('../../components/lists/List.vue'),
        meta: {
            title: 'router.router_subscriptions',
            prev: {
                name: 'dashboard'
            }
        },
        props ($route) {
            return {
                type: 'subscriptions',
                page: $route.query.page,
                withoutCreate: false,
            }
        }
    },
    {
        path: 'billing/subscriptions/create',
        name: 'subscriptions:create',
        component: () => import('../../components/billing/subscriptions/Create.vue'),
        meta: {
            title: 'router.router_addSubscription',
            prev: {
                name: 'subscriptions:list'
            }
        },
        props ($route) {
            return {
                copy: $route.params.copy,
                page: $route.query.page,
                type: $route.params.type || 'subscriptions'
            }
        }
    },
    {
        path: 'billing/subscriptions/:id/edit',
        name: 'subscriptions:edit',
        component: () => import('../../components/billing/subscriptions/Create.vue'),
        meta: {
            title: 'router.router_editSubscription',
            prev: {
                name: 'subscriptions:list'
            }
        },
        props ($route) {
            return {
                id: $route.params.id,
                type: $route.params.type || 'subscriptions',
                page: $route.query.page,
                copy: $route.params.copy,
            }
        }
    },
    {
        path: 'billing/statistics',
        name: 'statistics:list',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "billing" */'../../components/lists/List.vue'),
        meta: {
            title: 'router.router_billing',
            prev: {
                name: 'dashboard'
            }
        },
        props ($route) {
            return {
                type: 'statistics',
                page: $route.query.page,
                withoutCreate: true,
            }
        }
    },
    {
        path: 'billing/payment-services',
        name: 'payment-services:list',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "billing" */'../../components/lists/List.vue'),
        meta: {
            title: 'router.router_billing',
            prev: {
                name: 'dashboard'
            }
        },
        props ($route) {
            return {
                type: 'payment-services',
                page: $route.query.page,
                withoutCreate: false,
            }
        }
    },
    {
        path: 'payment/:result',
        name: 'payment:result',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "billing" */'../../components/billing/payment/Result.vue'),
        meta: {
            title: 'router.router_paymentResult',
            prev: {
                name: 'dashboard',
            }
        },
        props: true,
    },
    {
        path: 'billing/payment-services/create',
        name: 'payment-services:create',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "billing" */'../../components/billing/payment-services/Create.vue'),
        meta: {
            title: 'router.router_addPaymentService',
            prev: {
                name: 'payment-services:list'
            }
        },
        props ($route) {
            return {
                copy: $route.params.copy,
                page: $route.query.page,
                type: $route.params.type || 'payment-services'
            }
        }
    },
    {
        path: 'billing/payment-services/:id/edit',
        name: 'payment-services:edit',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "billing" */'../../components/billing/payment-services/Create.vue'),
        meta: {
            title: 'router.router_editPaymentService',
            prev: {
                name: 'payment-services:list'
            }
        },
        props ($route) {
            return {
                id: $route.params.id,
                type: $route.params.type || 'payment-services',
                page: $route.query.page,
                copy: $route.params.copy,
            }
        }
    },
]
